import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../../_models/key-value-result-dto';

export class OwnerLogReturnedMailEditorResultDto {
    customerId: string;
    community: string;
    owner: string;
    mailingAddress1: string;
    mailingAddress2: string;

    @Type(() => KeyValueResultDto)
    returnedReasons: KeyValueResultDto[];

    @Type(() => KeyValueResultDto)
    mailClass: KeyValueResultDto[];

    @Type(() => KeyValueResultDto)
    mailType: KeyValueResultDto[];

    @Type(() => KeyValueResultDto)
    addressMatchesActions: KeyValueResultDto[];
}
